import { useEffect } from 'react';
import { Box, Container, Typography } from '@mui/material';
import Header from '../components/header';
import Footer from '../components/footer';
import { Eyebrow, Mono } from '../components/section';
import ceo from '../assets/ceo.jpg';
import { brand } from '../thema';
import { useTranslation } from 'react-i18next';
import useLanguage from '../useLanguage';

const MessagePage = () => {
    const { t, i18n } = useTranslation();
    const { language } = useLanguage();
    const list = <T,>(key: string) => t(key, { returnObjects: true }) as unknown as T[];

    useEffect(() => {
        i18n.changeLanguage(language);
    }, []);

    const bodySx = {
        fontSize: { xs: '0.9375rem', md: '1rem' },
        lineHeight: 2.1,
        color: brand.inkSub,
    };

    return (
        <Box sx={{ color: brand.ink }}>
            <Header textColor="#000000" backgroundColor="white" />
            <Box component="main">

                {/* 代表挨拶 */}
                <Container maxWidth="lg" sx={{ px: { xs: 3, md: 4 }, pt: { xs: 16, md: 20 }, pb: { xs: 10, md: 16 } }}>
                    <Eyebrow label={t('messagePage.eyebrow')} />
                    <Typography component="h1" sx={{ mt: 2.5, fontSize: { xs: '2rem', md: '3rem' }, fontWeight: 700, letterSpacing: '0.03em' }}>
                        {t('messagePage.pageTitle')}
                    </Typography>

                    <Box sx={{ mt: { xs: 6, md: 10 }, display: 'grid', gridTemplateColumns: { xs: '1fr', md: '5fr 7fr' }, gap: { xs: 6, md: 10 }, alignItems: 'start' }}>
                        {/* 写真 */}
                        <Box>
                            <Box
                                component="img"
                                src={ceo}
                                alt={t('messagePage.photoAlt')}
                                sx={{ display: 'block', width: '100%', maxWidth: { xs: 360, md: 'none' }, height: 'auto' }}
                            />
                            <Box sx={{ mt: 2.5 }}>
                                <Mono color={brand.accentText}>{t('messagePage.role')}</Mono>
                                <Typography sx={{ mt: 0.75, fontSize: '1.25rem', fontWeight: 700, letterSpacing: '0.08em' }}>{t('Representative1')}</Typography>
                            </Box>
                        </Box>

                        {/* メッセージ */}
                        <Box>
                            <Typography component="h2" sx={{ fontSize: { xs: '1.5rem', md: '2.25rem' }, fontWeight: 700, lineHeight: 1.6, letterSpacing: '0.03em', whiteSpace: 'pre-line' }}>
                                {t('messagePage.title')}
                            </Typography>
                            <Box sx={{ mt: 5, display: 'flex', flexDirection: 'column', gap: 3, maxWidth: 680 }}>
                                {list<string>('messagePage.paragraphs').map((p) => (
                                    <Typography key={p} sx={bodySx}>{p}</Typography>
                                ))}
                                <Typography sx={{ my: 2, pl: 2.5, borderLeft: `2px solid ${brand.accent}`, fontSize: { xs: '1.125rem', md: '1.375rem' }, fontWeight: 700, lineHeight: 1.8, color: brand.ink, whiteSpace: 'pre-line' }}>
                                    {t('messagePage.statement')}
                                </Typography>
                                {list<string>('messagePage.closing').map((p) => (
                                    <Typography key={p} sx={bodySx}>{p}</Typography>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Box>

            <Footer />
        </Box>
    );
};

export default MessagePage;
